import { GenericBackendResponse } from '../genericBackendResponse';

interface ContactExpertRequest {
	message: string;
}

interface ContactExpertResponse {
	success: boolean;
	message?: string;
}

const contactExpert = async (
	token: string,
	data: ContactExpertRequest
): Promise<GenericBackendResponse<ContactExpertResponse>> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/pension-plan-transfers/contact-expert`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			body: JSON.stringify(data)
		}
	);

	const responseData = await response.json();

	return responseData;
};

export default contactExpert;
